import React, { useState, useEffect, useCallback } from 'react';
import { Creators as RespCreators } from 'store/ducks/companyResponsibility';
import { connect } from 'react-redux';
import { Container, SelectStyled } from './styles';
import ResponsibleOrder from '../../../TaskList/Row/ResponsibleOrderModal';

function Responsibility({
  _setResponsibilities,
  _getResponsibilities,
  roles,
  task,
  responsibility_bucket_id,
  loadingVisibleModal,
}) {
  const [isModalResp, setIsModalResp] = useState(false);
  const [responsibilitySelected, setResponsibilitySelected] = useState({});

  useEffect(() => {
    if (roles.length === 0) {
      _getResponsibilities();
    }
  }, []);

  const openModal = (resp_bucket) => {
    const respSelected = roles.filter(role => role.responsibility_bucket_id === +resp_bucket);
    setResponsibilitySelected(...respSelected);
    setIsModalResp(true);
  };

  const capitalize = word => word[0].toUpperCase() + word.substr(1).toLowerCase();

  const getOptionsSelect = useCallback(
    () => (
      roles.map(o => (
        <option
          key={`${o.responsibility_bucket_id}-option`}
          value={o.responsibility_bucket_id}
        >
          {capitalize(o.company_responsibility)}
        </option>
      ))
    ),
    [roles, responsibility_bucket_id],
  );


  return (
    roles.length !== 0 && (
      <Container>
        <SelectStyled
          value={responsibility_bucket_id}
          onChange={e => openModal(e.target.value)}
        >
          {getOptionsSelect()}
        </SelectStyled>

        <ResponsibleOrder
          task={task}
          responsibilitySelected={responsibilitySelected}
          isOpen={isModalResp}
          closeModal={() => setIsModalResp(false)}
          loadingVisibleModal={loadingVisibleModal}
          _setResponsibilities={_setResponsibilities}
          isTaskDetail
        />
      </Container>
    )
  );
}

const mapStateToProps = state => ({
  responsibility_bucket_id: state.task.taskDetail.responsibility_bucket_id,
  loadingVisibleModal: state.ui.loaders.includes('COMPANY_RESP'),
});

const mapDispatchToProps = {
  _getResponsibilities: RespCreators.getResponsibilitiesRequest,
  _setResponsibilities: RespCreators.setResponsibilitiesRequest,
};


export default connect(mapStateToProps, mapDispatchToProps)(Responsibility);
